var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 12.148c1.401 0 2.696.647 3.538 1.72l.094.126.122-.051c.2-.078.406-.132.617-.164l.213-.023.216-.008a2.899 2.899 0 0 1 2.837 3.5l-.03.12.11.062a3.296 3.296 0 0 1 1.557 2.402l.02.213.006.203a3.298 3.298 0 0 1-3.113 3.295l-.187.005h-9.2a3.7 3.7 0 0 1-1.418-7.117l.127-.049.01-.15a4.502 4.502 0 0 1 4.048-4.063l.215-.016.218-.005zm0 1a3.5 3.5 0 0 0-3.5 3.5l.006.211.018.202-.086.111a2.699 2.699 0 0 0-2.338 2.676 2.699 2.699 0 0 0 2.53 2.695l.17.005h9.2a2.3 2.3 0 0 0 .526-4.54l-.164-.031-.063-.16a1.9 1.9 0 0 0-2.766-2.583l-.125.122-.166-.03a3.5 3.5 0 0 0-3.242-2.178zm1.02 2.39.063.052 2.463 2.457a.4.4 0 0 1 .051.504l-.051.063-.143.142a.4.4 0 0 1-.503.052l-.063-.052-1.535-1.534v3.526a.401.401 0 0 1-.244.369l-.075.023-.08.008h-.2a.401.401 0 0 1-.392-.32l-.009-.08v-3.526l-1.534 1.534a.4.4 0 0 1-.434.088l-.07-.036-.062-.052-.143-.142a.4.4 0 0 1-.051-.504l.051-.063 2.458-2.457a.4.4 0 0 1 .503-.052z",
    fill: "#AEAEBD",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload.843e4625.svg";
export { ForwardRef as ReactComponent };